import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite';
import classname from 'classnames';

const styles = StyleSheet.create({
  nextArrow: {
    ':before': {
      content: 'url("https://www.paypalobjects.com/images/Cause/ic_right.svg")',
      color: 'black',
    },
  },
  prevArrow: {
    ':before': {
      content: 'url("https://www.paypalobjects.com/images/Cause/ic_left.svg")',
      color: 'black',
    },
  },
});

export function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  let styleArrow = css(styles.nextArrow);
  const styling = classname(
    className,
    styleArrow,
    'vx_icon vx_icon-arrow-right-small'
  );
  return (
    <div
      className={styling}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    />
  );
}

export function SamplePrevArrow(props) {
  const { className, style, onClick } = props;

  let styleArrow = css(styles.prevArrow);
  const styling = classname(
    className,
    styleArrow,
    'vx_icon vx_icon-arrow-right-small'
  );
  return (
    <div
      className={styling}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    />
  );
}
